import { Component } from '@angular/core';

import { TreasuryService } from '../../core/treasury.service';

/**
 * Prerequisite banner surfacing whether today's Treasury rates are loaded.
 *
 * Rendered above the division landing and reports hub so it's always clear that
 * loading rates is Step 1. When not loaded it links to the Treasury screen;
 * once loaded it shows a confirmation. Purely reads {@link TreasuryService}.
 */
@Component({
  selector: 'app-treasury-status',
  standalone: false,
  templateUrl: './treasury-status.component.html',
  styleUrl: './treasury-status.component.scss'
})
export class TreasuryStatusComponent {
  constructor(readonly treasury: TreasuryService) {}
}
